import React from 'react';
import styled from '@emotion/styled';
import { Col } from 'react-bootstrap';

import * as Ph from '~/App/Components/Placeholder';

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 20px;
  height: 65px;
  box-shadow: 0 2px 4px 0 rgba(159, 159, 159, 0.5);
`;

const Panel = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden auto;
  padding: 15px 20px;
  justify-content: center;
  @media (min-width: 1440px) {
    flex-wrap: unset;
    display: flex;
  }
`;

const PanelCol = styled(Col)`
  width: 100%;
  max-width: 75vw;
  margin: auto;
  @media (min-width: 1440px) {
    width: 370px;
    margin: unset;
  }
`;

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
`;

const PreviewLoader = styled.div`
  margin: 10% auto;
  max-width: 1000px;
  height: 400px;
  border-radius: 8px;
  background-color: #ced4da;
`;

const PreviewLoaderContainer = styled.div`
  max-width: 100%;
  flex: 1 0 auto;
  .ph-item {
    margin: 0 80px 0 100px !important;
  }
  @media (max-width: 768px) {
    .ph-item {
      margin: 0 10px 0 10px !important;
    }
  }
`;

function PanelGroup({ height }: PanelGroupProps) {
  return (
    <Ph.Col size={12} style={{ marginBottom: 25, padding: 0, paddingLeft: 15 }}>
      <Ph.Row style={{ marginBottom: 0 }}>
        <Ph.Col
          size={12}
          style={{ height: height ?? 63, margin: 0, borderRadius: 8 }}
        />
      </Ph.Row>
    </Ph.Col>
  );
}

export function MessageTemplateLoading() {
  return (
    <Container>
      <HeaderContainer>
        <div></div>
      </HeaderContainer>
      <Panel>
        <PanelCol>
          <Ph.Item>
            <PanelGroup height={400} />
            <PanelGroup />
          </Ph.Item>
        </PanelCol>
        <PreviewLoaderContainer>
          <Ph.Item>
            <PreviewLoader />
          </Ph.Item>
        </PreviewLoaderContainer>
      </Panel>
    </Container>
  );
}
